import { render, staticRenderFns } from "./PayforRoom.vue?vue&type=template&id=11cb5d10"
import script from "./PayforRoom.vue?vue&type=script&lang=js"
export * from "./PayforRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports